export interface RuntimeConfig {
  pusherKey: string;
  pusherCluster: string;
  sentryDsn: string;
  environment: string;
}

declare global {
  interface Window {
    __CALLKARMA_RUNTIME_CONFIG__: RuntimeConfig | null;
  }
}

const emptyRuntimeConfig: RuntimeConfig = {
  pusherKey: "",
  pusherCluster: "",
  sentryDsn: "",
  environment: "development",
};

export const runtimeConfig: RuntimeConfig =
  window.__CALLKARMA_RUNTIME_CONFIG__ ?? emptyRuntimeConfig;
